module.exports = __webpack_public_path__ + "static/media/arrow-icon.9f53b279.svg";